import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Rules, RulesForm} from '../../contract/models/rules';


export const ruleDuplicateActionTypes = {
  DUPLICATE: type('[rule] Duplicate'),
  DUPLICATE_SUCCESS: type('[rule] Duplicate Success'),
  DUPLICATE_FAIL: type('[rule] Duplicate Fail'),
};

export class DuplicationRuleAction implements Action {
  readonly type = ruleDuplicateActionTypes.DUPLICATE;
  constructor(public payload?: {ruleForm: RulesForm , contractUuid: string }) {}
}

export class DuplicationRuleSuccessAction implements Action {
  readonly type = ruleDuplicateActionTypes.DUPLICATE_SUCCESS;
  constructor(public payload?: Rules) {}
}

export class DuplicationRuleFailAction implements Action {
  readonly type = ruleDuplicateActionTypes.DUPLICATE_FAIL;
  constructor(public payload?: string) {}
}


